import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { MatButton } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { SnackbarCustomService } from '../../../../shared/components/snackbar/snackbar-custom.service'
import { ResponseRequestModel } from '../../../../core/models/response.model'
import { MatInputModule } from '@angular/material/input'
import { MatOption } from '@angular/material/core'
import { MatSelect } from '@angular/material/select'
import { ProfileTypeService } from '../../../../core/services/contact/contact-type/contact-type.service'
import { NgxMaskDirective } from 'ngx-mask'
import {MatTimepicker, MatTimepickerInput, MatTimepickerToggle} from '@angular/material/timepicker';
import {WeekDaysService} from '../../../../core/services/reminder/week-days/week-days.service';
import {NgForOf} from '@angular/common';
import {MessageService} from '../../../../core/services/message/message/message.service';
import {TimeService} from '../../../../core/services/time/alert/time.service';

@Component({
  selector: 'alert-patient-form',
  imports: [
    FormsModule,
    MatButton,
    MatProgressSpinner,
    ReactiveFormsModule,
    MatInputModule,
    MatOption,
    MatSelect,
    NgxMaskDirective,
    MatTimepickerToggle,
    MatTimepicker,
    MatTimepickerInput,
    NgForOf,
  ],
  templateUrl: './alert-patient-form.component.html',
  styleUrl: './alert-patient-form.component.scss',
  providers: [ProfileTypeService],
  standalone: true,
})
export class AlertPatientFormComponent implements OnInit, OnChanges {
  constructor(
    private formBuilder: FormBuilder,
    private snackbar: SnackbarCustomService,
    private weekDaysService: WeekDaysService,
    private messageService: MessageService,
    private timeService: TimeService,
  ) {}
  diasSemanaList: any[] = []
  messagesList: any[] = []
  timeList: any[] = []
  form: FormGroup = new FormGroup({})
  loading: boolean = false

  @Output() response = new EventEmitter()
  @Input() editItem: any = {}

  listType: any[] = []

  ngOnInit(): void {
  //  this.getListType()
    this.createForm()
    this.getDiasSemana()
    this.getMensagens()
    this.getHorarios()
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes['editItem']) {
      this.treatmentItem()
    }
  }
  getMensagens(){
    this.messageService.listMessage("?tipo_uso=1").subscribe({
      next: (response: ResponseRequestModel) => {
        console.log(response,'response')
        //@ts-ignore
        this.messagesList = response.data
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => {},
    })
  }
  getHorarios(){
    this.timeService.listTime().subscribe({
      next: (response: ResponseRequestModel) => {
        console.log(response,'response')
        //@ts-ignore
        this.timeList = response.data
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => {},
    })
  }
  getDiasSemana(){
    this.weekDaysService.listWeekDays().subscribe({
      next: (response: ResponseRequestModel) => {
        this.diasSemanaList = [
          {id: 'todos', descricao: 'Todos'},
          ...response.data
        ]
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => {},
    })
  }
  private treatmentItem() {
    if (this.checkEdit()) {
      this.form.reset()
      this.fillForm()
    }
  }

  // getListType() {
  //   this.contactTypeService.listContactType().subscribe({
  //     next: (response: ResponseRequestModel) => {
  //       this.listType = response.data
  //     },
  //     error: (err: ResponseRequestModel) => {
  //       console.error(err)
  //     },
  //     complete: () => {},
  //   })
  // }

  checkEdit() {
    if (this.editItem) {
      if (this.editItem.idCreate) {
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  }

  fillForm() {
    this.form.get('time')?.setValue(this.editItem.horarios)
    this.form.get('weekDays')?.setValue(this.editItem.dias_semana)
    this.form.get('messages')?.setValue(this.editItem.id_mensagem_template)
  }

  resetForm() {
    this.form.reset()
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      time: [[], [Validators.required]],
      weekDays: [[], [Validators.required]],
      messages: [null, [Validators.required]],
    })
    this.form.get('weekDays')?.valueChanges.subscribe((selected: any[]) => {
      this.handleWeekDaysChange(selected)
    })
  }
  private previousValue: any[] = []

  handleWeekDaysChange(selected: any[]): void {
    const allDaysExceptTodos = this.diasSemanaList
      .filter(day => day.id !== 'todos')
      .map(day => day.id)

    const hadTodos = this.previousValue.includes('todos')
    const hasTodos = selected.includes('todos')

    // 1. "Todos" foi marcado agora
    if (!hadTodos && hasTodos) {
      this.form.get('weekDays')?.setValue(
        ['todos', ...allDaysExceptTodos],
        { emitEvent: false }
      )
      this.previousValue = ['todos', ...allDaysExceptTodos]
      return
    }

    // 2. "Todos" foi desmarcado
    if (hadTodos && !hasTodos) {
      const withoutTodos = selected.filter(id => id !== 'todos')
      this.form.get('weekDays')?.setValue([], { emitEvent: false })
      this.previousValue = []
      return
    }

    // 3. Opção individual desmarcada (com "todos" marcado)
    if (hasTodos && selected.length < this.diasSemanaList.length) {
      const withoutTodos = selected.filter(id => id !== 'todos')
      this.form.get('weekDays')?.setValue(withoutTodos, { emitEvent: false })
      this.previousValue = withoutTodos
      return
    }

    // 4. Todas opções individuais marcadas manualmente
    const allIndividualDaysSelected = allDaysExceptTodos.length > 0 &&
      allDaysExceptTodos.every(id => selected.includes(id))

    if (allIndividualDaysSelected && !hasTodos) {
      this.form.get('weekDays')?.setValue(
        ['todos', ...allDaysExceptTodos],
        { emitEvent: false }
      )
      this.previousValue = ['todos', ...allDaysExceptTodos]
      return
    }

    // Atualiza o valor anterior
    this.previousValue = selected
  }  // getTypeDescription() {
  //   let typeId = this.form.get('typeContact')?.value
  //   if (typeId) {
  //     let element = this.listType.find((ele: any) => {
  //       return ele.id === typeId
  //     })
  //     return element.descricao
  //   } else {
  //     return ''
  //   }
  // }

  createContact() {
    this.loading = true
    const model = this.createModel()
    this.response.emit({ action: 'create', item: model })
    this.resetForm()
    this.loading = false
  }

  editContact() {
    this.loading = true
    const model = this.createModel(true)
    this.response.emit({ action: 'edit', item: model })
    this.resetForm()
    this.loading = false
  }

  deleteContact() {
    this.loading = true
    const model = this.createModel(true)
    this.response.emit({ action: 'delete', item: model })
    this.resetForm()
    this.loading = false
  }

  cancel() {
    this.response.emit({ action: 'cancel' })
    this.resetForm()
  }

  createModel(edit: boolean = false) {
    const selectedDays = this.form.controls['weekDays'].value; // ex: [1, 3, 5]
    const selectedTimes = this.form.controls['time'].value; // ex: [1, 3, 5]
    const selectedMessage = this.form.controls['messages'].value;

    // Remove 'todos' dos dias selecionados
    const daysWithoutTodos = selectedDays.filter((id: string) => id !== 'todos');

    const dias_semana_descricao = daysWithoutTodos
      .map((id: string) => {
        const day = this.diasSemanaList.find(d => d.id === id);
        return day ? day.descricao : '';
      })
      .join(', ');

    const mensagem_descricao = this.messagesList.find(d => d.id === selectedMessage)?.texto;

    const horas_descricao = selectedTimes
      .map((id: string) => {
        const day = this.timeList.find(d => d.id === id);
        return day ? day.hora : '';
      })
      .join(', ');

    if (edit) {
      return {
        idCreate: this.editItem.idCreate,
        horarios: this.form.controls['time'].value,
        dias_semana: daysWithoutTodos, // sem 'todos'
        dias_semana_descricao,
        horas_descricao,
        mensagem_descricao,
        descricao: '.',
        id_mensagem_template: this.form.controls['messages'].value,
      }
    } else {
      return {
        horarios: this.form.controls['time'].value,
        descricao: '.',
        dias_semana_descricao,
        horas_descricao,
        mensagem_descricao,
        dias_semana: daysWithoutTodos, // sem 'todos'
        id_mensagem_template: this.form.controls['messages'].value,
      }
    }
  }}
